// Tiny inline SVG flags — crisp on every screen, no emoji-font dependency
// (Windows doesn't render national flag emoji by default).

export function FlagBE({ className = "" }) {
  return (
    <svg
      viewBox="0 0 3 2"
      className={className}
      role="img"
      aria-label="België"
      style={{ display: "inline-block" }}
    >
      <rect width="1" height="2" x="0" fill="#000" />
      <rect width="1" height="2" x="1" fill="#FAE042" />
      <rect width="1" height="2" x="2" fill="#ED2939" />
    </svg>
  );
}

export function FlagNL({ className = "" }) {
  return (
    <svg
      viewBox="0 0 9 6"
      className={className}
      role="img"
      aria-label="Nederland"
      style={{ display: "inline-block" }}
    >
      <rect width="9" height="2" y="0" fill="#AE1C28" />
      <rect width="9" height="2" y="2" fill="#FFFFFF" />
      <rect width="9" height="2" y="4" fill="#21468B" />
    </svg>
  );
}

export function FlagsBENL({ size = "md" }) {
  const sizeCls = {
    sm: "w-3.5 h-2.5",
    md: "w-4 h-3",
    lg: "w-5 h-4",
  }[size];
  return (
    <span className="inline-flex items-center gap-1 align-middle">
      <FlagBE className={`${sizeCls} rounded-[1px] ring-1 ring-black/10`} />
      <FlagNL className={`${sizeCls} rounded-[1px] ring-1 ring-black/10`} />
    </span>
  );
}
